<template>
  <div class="flex flex-col lg:h-0 lg:min-h-full">
    <div class="flex-none px-2">
      <h5 class="text-sm font-medium text-gray-600 mb-2">
        Tasks &bull;
        <VDropdown right v-if="$membershipHasPermissionTo('create tasks')">
          <template #button="buttonProps">
            <button
              class="bg-gray-300 text-blue-600 px-4 py-1 rounded leading-6 hover:bg-blue-600 hover:text-white focus:outline-none disabled:text-gray-600"
              @click="buttonProps.open"
            >
              New Task
            </button>
          </template>

          <template #default="defaultProps">
            <VDropdownMenu>
              <button
                v-for="(taskTemplate, idx) in taskTemplates"
                :key="idx"
                role="button"
                :class="[
                  'block',
                  'px-4',
                  'py-2',
                  'hover:bg-gray-200',
                  'disabled:bg-blue-600',
                  'disabled:text-white',
                  'transition-color',
                  'transition-fast',
                  'text-right',
                  'text-sm',
                  'w-full',
                ]"
                @click="defaultProps.close(() => newTaskFromTemplate(idx))"
              >
                {{ taskTemplate.label }}
              </button>
            </VDropdownMenu>
          </template>
        </VDropdown>
      </h5>
    </div>
    <div class="flex-1 lg:h-0">
      <div class="h-full overflow-auto fancy-scrollbar px-2">
        <div>
          <div v-if="taskFormVisible" class="bg-white p-4 rounded">
            <TaskForm
              :action="storeTask"
              :task="defaultData"
              :member-options="memberOptions"
              @cancel="taskFormVisible = false"
            />
          </div>
          <Tasks v-else :contact-request="contactRequest" :member-options="memberOptions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VDropdown from '@/components/Common/VDropdown.vue';
import VDropdownMenu from '@/components/Common/VDropdownMenu.vue';
import TaskForm from './taskManager/TaskForm.vue';
import Tasks from './taskManager/Tasks.vue';

export default {
  name: 'ContactActivity',

  components: {
    Tasks,
    TaskForm,
    VDropdown,
    VDropdownMenu,
  },
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      taskFormVisible: false,
      defaultData: {},
      taskTemplates: [
        {
          label: 'Τηλεφωνικό ραντεβού',
          defaultData: {
            title: 'Τηλεφωνικό ραντεβού',
          },
        },
        {
          label: 'Επανάκληση',
          defaultData: {
            title: 'Επανάκληση',
          },
        },
        {
          label: 'Φυσικό ραντεβού',
          defaultData: {
            title: 'Φυσικό ραντεβού',
          },
        },
        {
          label: 'Ραντεβού εγγραφής',
          defaultData: {
            title: 'Ραντεβού εγγραφής',
          },
        },
        {
          label: 'Κενό',
          defaultData: {},
        },
      ],
    };
  },
  computed: {
    account() {
      return this.$store.state.entities.accounts.byId[this.contactRequest.accountId];
    },
    accountMembers() {
      return this.$store.getters['ui/accountMembers/membersByAccount'](
        this.contactRequest.accountId
      );
    },
    memberOptions() {
      return this.accountMembers.map((member) => ({
        value: member.id,
        label: member.fullName,
      }));
    },
  },
  methods: {
    newTaskFromTemplate(index) {
      const { defaultData = {} } = this.taskTemplates[index] || {};

      this.defaultData = defaultData;
      this.taskFormVisible = true;
    },
    async storeTask(formData) {
      try {
        await this.$store.dispatch('ui/contactRequestTasks/store', {
          id: this.contactRequest.id,
          formData,
        });

        this.taskFormVisible = false;

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
